import React from 'react';
import { usePopupNotificationModal } from '../../hooks/usePopupNotificationModal';
import { NotificationModal } from '../../ui-components/NotificationModal';

export const PopupNotification: React.FC = () => {
  const { notification, isOpen, close } = usePopupNotificationModal();

  if (!notification) {
    return null;
  }

  return (
    <NotificationModal
      open={isOpen}
      title={notification.title}
      body={notification.body}
      handleClose={close}
    />
  );
};
